import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Check } from 'lucide-react';

// Mixins / Modules
import Window from '../../../../../../modules/window';

// Models
import User from '../../../../../../models/v2/user';

// Base
import Button from '../../../../base/button';
import Card from '../../../../base/card';

// Related Components
import Popup from './personal/popup';

export default class Personal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    plan: PropTypes.string.isRequired,
    duration: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    onSetDuration: PropTypes.func.isRequired,
    onSubscribe: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      sending: false,
      duration: props.duration,
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.duration !== nextState.duration) {
      return { duration: nextProps.duration};
    }
    return null;
  }

  get isSelected() {
    const { plan } = this.props;
    return plan === 'personal';
  }

  handleOpen = () => {
    const { onSelect } = this.props;
    this.setState({
      isOpen: true
    }, () => onSelect('personal'));
  }

  handleSetDuration = (duration) => {
    const { onSetDuration } = this.props;
    this.setState({
      duration
    }, () => onSetDuration(duration));
  }

  handleClose = () => {
    this.setState({ isOpen: false });
  }

  handleConfirm = () => {
    const { user, duration, onSubscribe } = this.props;
    const { sending } = this.state;

    if (sending) return;

    this.setState({
      sending: true,
      isOpen: false,
    }, () => {
      const data = {
        id: user.id,
        plan_name: 'personal',
        plan_duration: duration,
        plan_message: '',
        plan_promo: '',
        send_plan_notification: true,
      };
      (new User(data))
        .save()
        .then((user) => {
          onSubscribe(user, 'congratulations');
        })
        .catch((error) => {
          Window.flash.error(error);
          this.setState({ sending: false });
        })
    })
  }

  render() {
    const { duration, onSelect } = this.props;
    const { isOpen, sending } = this.state;

    return (
      <Card {...{
        className: classNames('personal standard-card width-380 height-625 relative padding-left-31', {
          selected: this.isSelected,
          hoverable: !this.isSelected,
        }),
        onClick: () => onSelect('personal'),
      }}>
        <div className='heading xlg-font semi-bold height-38 margin-top-40'>
          Personal
        </div>
        <div className='sub-heading xsm-font'>
          1 Single User
        </div>
        <div className='pricing-card-list'>
          <div className='xl2-font price'>
            ${ duration === 'monthly' ? '109' : '1,112'}
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Full Access to Entire Platform.
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Unlimited Private Contact Imports
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Access to Consultant Network6
            </div>
          </div>
          <div className='height-52 flex margin-bottom-15'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Unlimited Messaging &amp;<br />
              Campaigns
            </div>
          </div>
          <div className='height-52 flex margin-bottom-15'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              AI-Powered & Automated<br />
              Workflow Tools
            </div>
          </div>
          <div className='height-40 flex'>
            <div className='inline-block margin-right-10'><Check /></div>
            <div className='inline-block sm-font line-height-26'>
              Dedicated Success Specialist
            </div>
          </div>
          <div className='absolute bottom-40 left-31 width-290'>
            <Button {...{
              text: 'GET PERSONAL',
              block: true,
              className: 'border-radius-4',
              size: 'xlg',
              onClick: () => this.handleOpen(),
              disabled: sending,
            }} />
          </div>
          <Popup {...{
            duration,
            isOpen,
            onSetDuration: this.handleSetDuration,
            onConfirm: this.handleConfirm,
            onCancel: this.handleClose,
          }} />
        </div>
      </Card>
    )
  }
}